<ion-header collapse="fade">
  <ion-toolbar>
    <ion-title role="heading" aria-level="1" mode="md">
      {{ 'page.my-projects' | translate }}
      <span></span>
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="app__description">
    <p>{{ 'page.my-projects.desc' | translate }}</p>
  </div>
  <div class="app__content projects">
    <ng-container *ngIf="projects.length > 0">
      <app-search-item
        [@slideOut]
        *ngFor="let project of projects"
        (removed)="removeProject($event)"
        [project]="project"
      ></app-search-item>
    </ng-container>
    @if (projects.length === 0 && projectsLoaded) {
    <app-state-notice
      iconPath="/assets/illustrations/no_projects.svg"
      [title]="'projects.empty.title' | translate"
      [desc]="(suggestions.length ? 'projects.empty.suggestions' : 'projects.empty.desc') | translate"
    />
    }
    <ng-container
      *ngIf="!projects.length && suggestions.length && projectsLoaded"
    >
      <app-search-item
        [loading]="false"
        [withDistance]="suggestion.item.distance"
        *ngFor="let suggestion of suggestions"
        [location]="suggestion.location"
        [project]="suggestion.item"
      ></app-search-item>
    </ng-container>
  </div>
  <app-loader
    [full]="true"
    [loading]="!projectsLoaded"
    [hidden]="projectsLoaded"
  ></app-loader>
</ion-content>
